/* eslint-disable */
export default {
  doNotCall: 'Do Not Call',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
